import script from "./AboutComp.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutComp.vue?vue&type=script&setup=true&lang=js"

import "./AboutComp.vue?vue&type=style&index=0&id=3ab18ad4&scoped=true&lang=css"

import exportComponent from "/Users/nattkpk/Dev/S3Code/s3invent-trueeye_website_v2.5_nattkpk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ab18ad4"]])

export default __exports__